<script setup lang="ts">
import QueueDuration from "~/components/queue/QueueDuration.vue";
import QueueThroughput from "~/components/queue/QueueThroughput.vue";
import QueueHourData from "~/dto/queue/QueueHourData";

defineProps({
  queueHourData: {
    type: QueueHourData,
    required: true
  },
  widgetClass: {
    type: String,
    default: 'col-4 mb-3'
  }
});
</script>

<template>
  <div :class="widgetClass">
    <QueueDuration :value="queueHourData.duration" />
  </div>
  <div :class="widgetClass">
    <QueueThroughput :value="queueHourData.throughput" />
  </div>
</template>